// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDropzone,
} from 'react-dropzone'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
} from 'data'

// pages
import {
    Button825,
    ErrorHelper825,
    FormLabel825,
} from 'pages'

// props
type FileInput825Props = {
    disabled?: boolean
    error?: string
    helperText?: string
    label?: string
    name: string
    onChange: any
    pdfOk?: boolean
    pdfOnly?: boolean
    value: any
}

// main
export const FileInput825: React.FC<FileInput825Props> = React.memo(({
    disabled,
    error,
    helperText,
    label,
    name,
    onChange,
    pdfOk,
    pdfOnly,
    value,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const [files, setFiles] = useState<any>([])
    const [uploadError, setUploadError] = useState<string>()

    let acceptObject = {}
    if (name === 'storage_file') {
        acceptObject = {
            'application/pdf': [],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [], // .docx
            'audio/x-m4a': [],
            'image/avif': [],
            'image/gif': [],
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
            'image/svg+xml': [],
            'image/webp': [],
        }
    } else if (pdfOnly) {
        acceptObject = {
            'application/pdf': [],
        }
    } else if (pdfOk) {
        acceptObject = {
            'application/pdf': [],
            'image/avif': [],
            'image/gif': [],
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
            'image/svg+xml': [],
            'image/webp': [],
        }
    } else {
        acceptObject = {
            'image/avif': [],
            'image/gif': [],
            'image/jpeg': [],
            'image/jpg': [],
            'image/png': [],
            'image/webp': [],
        }
    }
    const { getRootProps, getInputProps } = useDropzone({
        accept: acceptObject,
        maxSize: 64000000,
        onDrop: (acceptedFiles, fileRejections) => {
            const files = acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            }))
            if (files[0]?.preview) {
                setUploadError(undefined)
                setFiles(files)
                onChange({
                    fileName: acceptedFiles[0].name.replace(/\.[^/.]+$/, ''),
                    name: name,
                    value: acceptedFiles[0],
                })
            }
            else {
                fileRejections.map(({ file, errors }) => {
                    const formattedErrors = errors.map(error => {
                        if (error.code === 'file-too-large') {
                            return `${reduxText[10231]} ${(64000000 / (1024 * 1024)).toFixed()}MB.`
                        } else {
                            return error.message
                        }
                    }).join(' ')
                    setUploadError(formattedErrors)
                })
            }
        }
    })

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach((file: any) => URL.revokeObjectURL(file.preview))
    }, [
        files,
    ])

    const isPDF = files[0]?.type === 'application/pdf' || pdfOnly || (pdfOk && String(value).endsWith('.pdf'))
    const isOtherFile = (
        files[0]?.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ) || (
            files[0]?.type === 'audio/x-m4a'
        ) || (
            name === 'storage_file' && (
                value?.endsWith('.docx')
            )
        )

    if (label) {
        return (
            <div className={`input-wrap-825${disabled ? ' disabled' : ''}`}>
                <div className='input-label-wrap'>
                    <FormLabel825
                        formInput={pdfOnly ? 'pdf' : 'image'}
                        helperText={helperText}
                        label={label}
                        name={name}
                        translationDefaultValue={value}
                    />
                </div>
                <div className='file-input-825'>
                    <div className='fi-input-div full'>
                        <div {...getRootProps({ className: 'fi-image-add-wrap' })}>
                            {(value !== 'to_delete' && (files[0] || value))
                                ? (
                                    (isPDF || isOtherFile)
                                        ? (
                                            <div className='fi-input'>
                                                <p className='mo-dropzone-helper-text'>{isPDF ? 'PDF' : 'File'}</p>
                                                <p className='mo-dropzone-helper-text mo-clamp-web5'>{files[0] ? files[0].preview : (value.preview || value)}</p>
                                            </div>
                                        ) : (
                                            <img
                                                alt=''
                                                className='fi-preview-img'
                                                src={files[0] ? files[0].preview : (value.preview || value)}
                                            />
                                        )
                                ) : (
                                    <>
                                        {uploadError
                                            ? (
                                                <div className='fi-input error'>
                                                    <i className='m-icon mo-new-icon-times-solid' />
                                                    <p className='mo-dropzone-helper-text'>{uploadError}</p>
                                                </div>
                                            ) : (
                                                <div className='fi-input'>
                                                    <i className='m-icon mo-new-icon-cloud-upload-alt-solid' />
                                                    <p className='mo-dropzone-helper-text'>{reduxText[8695]}</p>
                                                </div>
                                            )
                                        }
                                    </>
                                )}
                            <input {...getInputProps()} />
                        </div>
                        {(value !== 'to_delete' && (files[0] || value)) && (
                            <div className='fi-buttons-wrap'>
                                {(isPDF || isOtherFile) && (
                                    <div className='fi-buttons-div'>
                                        <Button825
                                            className='fi-button'
                                            edit={false}
                                            href={value.preview || value}
                                            size='x-small'
                                            text={reduxText[10232]}
                                        />
                                    </div>
                                )}
                                <div className='fi-buttons-div'>
                                    <Button825
                                        className='fi-button'
                                        edit={false}
                                        onClick={() => {
                                            onChange({
                                                doka_image: 'to_delete',
                                                doka_output_data: 'to_delete',
                                                name: name,
                                                value: 'to_delete',
                                            })
                                        }}
                                        size='x-small'
                                        text={reduxText[10232]}
                                    />
                                </div>
                                <div {...getRootProps({ className: 'fi-buttons-div fi-dropzone-input' })}>
                                    <Button825
                                        className='fi-button'
                                        edit={false}
                                        size='x-small'
                                        text={reduxText[10233]}
                                    />
                                    <input {...getInputProps()} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ErrorHelper825 error={error} />
            </div>
        )
    }

    return (
        <div className='file-input-825'>
            <div className='fi-input-div'>
                <div {...getRootProps({ className: 'fi-image-add-wrap' })}>
                    {(value !== 'to_delete' && (files[0] || value))
                        ? (
                            (isPDF || isOtherFile)
                                ? (
                                    <div className='fi-input'>
                                        <p className='mo-dropzone-helper-text'>{isPDF ? 'PDF' : 'File'}</p>
                                        <p className='mo-dropzone-helper-text mo-clamp-web5'>{files[0] ? files[0].preview : (value.preview || value)}</p>
                                    </div>
                                ) : (
                                    <img
                                        alt=''
                                        className='fi-preview-img'
                                        src={files[0] ? files[0].preview : (value.preview || value)}
                                    />
                                )
                        ) : (
                            <>
                                {uploadError
                                    ? (
                                        <div className='fi-input error'>
                                            <i className='m-icon mo-new-icon-times-solid' />
                                            <p className='mo-dropzone-helper-text'>{uploadError}</p>
                                        </div>
                                    ) : (
                                        <div className='fi-input'>
                                            <i className='m-icon mo-new-icon-cloud-upload-alt-solid' />
                                            <p className='mo-dropzone-helper-text'>{reduxText[8695]}</p>
                                        </div>
                                    )
                                }
                            </>
                        )}
                    <input {...getInputProps()} />
                </div>
                {(value !== 'to_delete' && (files[0] || value)) && (
                    <div className='fi-buttons-wrap'>
                        <div className='fi-buttons-div'>
                            <Button825
                                className='fi-button'
                                edit={false}
                                onClick={() => {
                                    onChange({
                                        doka_image: 'to_delete',
                                        doka_output_data: 'to_delete',
                                        name: name,
                                        value: 'to_delete',
                                    })
                                }}
                                size='x-small'
                                text={reduxText[10232]}
                            />
                        </div>
                        <div {...getRootProps({ className: 'fi-buttons-div fi-dropzone-input' })}>
                            <Button825
                                className='fi-button'
                                edit={false}
                                size='x-small'
                                text={reduxText[10233]}
                            />
                            <input {...getInputProps()} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
})
